import Image from "next/image"
import { useContext, useEffect, useState } from "react"
import { WalletContext } from "../../contexts/WalletContext"
import useAuth from "../../hooks/useAuth"
import { useRouter } from 'next/router';


export default function MenuWallet(props: any) {
	const { isMarketplace, isMobile, isFashionIndex } = props
	const [connectClicked, setConnectClick] = useState(false)
	const { connect, disconnect, getFormattedAddress, web3Provider } =
		useContext(WalletContext)
	const {get_access_token} = useAuth()
	const router = useRouter()


	useEffect(() => {
		if (web3Provider && !connectClicked) setConnectClick(true)
		if (!connectClicked) return
	}, [web3Provider])

	// console.log('web3Provider--->', web3Provider)

	async function onclickConnect() {
		console.log('onclickConnect')
		let token = await get_access_token()
		if (!token) {
			console.log('onclickConnect no token')
			router.replace('/login')
			return
		}
		if (!web3Provider) {
			console.log('onclickConnect no web3Provider')
			setConnectClick(true)
			await connect()
			return
		}
		console.log('onclickConnect redirect to my-hapes')
		router.replace('/my-hapes')
	}

	return (
		<>
			{!web3Provider && (
				<>
					{!isMobile && (
						<Image
							onClick={onclickConnect}
							src={`/static/img/wallet/wallet_closed.svg`}
							priority={true}
							width={35}
							height={27}
							quality={100}
							alt={"Wallet"}
						/>
					)}
					{isMobile && (
						<>
							{!isFashionIndex ? (
								<Image
									onClick={onclickConnect}
									src={`/static/img/wallet/wallet_closed_black.svg`}
									priority={true}
									width={22}
									height={17}
									quality={100}
									alt={"Wallet"}
								/>
							) : (
								<Image
									onClick={onclickConnect}
									src={`/static/img/navbar/wallet_connect.svg`}
									priority={true}
									width={22}
									height={17}
									quality={100}
									alt={"Wallet"}
								/>
							)}
						</>
					)}
				</>
			)}

			{web3Provider && (
				<>
					{!isMobile && (
						<Image
							onClick={onclickConnect}
							src={`/static/img/wallet/wallet_closed.svg`}
							priority={true}
							width={35}
							height={27}
							quality={100}
							alt={"Wallet"}
						/>
					)}
					{isMobile && (
						<>
							{!isFashionIndex ? (
								<Image
									onClick={onclickConnect}
									src={`/static/img/wallet/wallet_closed_black.svg`}
									priority={true}
									width={22}
									height={17}
									quality={100}
									alt={"Wallet"}
								/>
							) : (
								<Image
									onClick={onclickConnect}
									src={`/static/img/navbar/wallet_connect.svg`}
									priority={true}
									width={22}
									height={17}
									quality={100}
									alt={"Wallet"}
								/>
							)}
						</>
					)}
					{!isMobile && <div>{getFormattedAddress()}</div>}
					{/* {isMobile && <div style={{ fontSize: '10px', color: '#8E8E8E'}}>{getFormattedAddress()}</div>} */}
				</>
			)}
		</>
	)
}
